import { useState } from "react";

const useVideoModal = () => {
  const [show, setShow] = useState(false);
  const [videoActivo, setVideoActivo] = useState(null);

  const handleShow = (video) => {
    setVideoActivo(video);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setVideoActivo(null);
  };

  return { show, videoActivo, handleShow, handleClose };
};

export default useVideoModal;
